import { c as t } from "./index766.mjs";
import { g as a } from "./index873.mjs";
import { i as e } from "./index815.mjs";
import { i as s } from "./index872.mjs";
import { w as i } from "./index760.mjs";
var l = t, o = a, m = e, f = s, n = i, d = n("iterator"), u = function(r) {
  if (!m(r))
    return o(r, d) || o(r, "@@iterator") || f[l(r)];
};
export {
  u as g
};
